<template>
    <div>
        <!-- <div class="title py-2 px-4 title-div mt-5 mb-6">
            {{$route.params.title}}
            ss
        </div> -->
        <div v-if="$route.params.id === 'profile'">
            <p class="display-1 mb-5 primary--text">Division Heads</p>
            <div v-for="(n, index) in profiles" :key="index + 'profile'">
                <v-row>
                    <v-col cols="4" md="2">
                        <v-img
                        max-height="200" 
                        contain
                        :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        :lazy-src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                        class="transparent lighten-2"
                        >
                            <template v-slot:placeholder>
                                <v-layout
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                                </v-layout>
                            </template>
                        </v-img>
                    </v-col>
                </v-row>
                <p class="mt-3 text-xs-center"><a :href="`#/About Us/Senior Management/Profile/Deputy Attorney General`" class="title" >{{n.Title.split('#').length > 0 ? n.Title.split('#')[1] : ''}}</a><br>
                <span class="subheading text-xs-center">{{n.Title.split('#')[0]}}</span><br> </p>
            </div>
        </div>
        <div v-else>
            <p class="display-1 mb-5 primary--text" v-html="contents[0].Title"></p>
          
            <v-img
            :src="getImage(contents[0])"
            class="transparent mb-4"
            contain
            v-if="getImage(contents[0]) != '' && !agProfile"
            >
                <template v-slot:placeholder>
                    <v-layout
                    fill-height
                    align-center
                    justify-center
                    ma-0
                    >
                    <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                </template>
            </v-img>
            <div class="ql-editor px-0" v-html="contents[0] ? contents[0].Body : ''"></div>
            <!-- <div v-if="contents[0].Files.length > 0">
                <p class="title mt-4">Documents</p>
                <p v-for="a in getWithoutImages(contents[0].Files)" :key="a.ID + 'FileDownload'">
                    <v-icon color="primary" class="mr-2">mdi-file</v-icon><a :href="`${$url}/downloadfile/${a.ID}`" v-html="a.FileTitle"></a>
                </p>
            </div> -->
        </div>
    </div>
</template>
<script>
    export default {
        props: ['contents'],
        data: ()=>({
            profiles: []
        }),
        created () {
            console.log(this.$route.params)
            if (this.$route.params.id === 'profiles') {
                this.$http.get(`${this.$url}//pagination/2/Division%20Heads?limit=20&page=0&sort=id%20desc`).then((response) => {
                    this.profiles = response.data.data.rows
                })
            }
        },
        methods: {
            getWithoutImages (files) {
                return files.filter(item => !item.FileType.includes('image'))
            },
            getImage(item) {
                console.log('item.Files')
                if (item.Files && item.Files.length > 0) {
                    let images = item.Files.filter(obj => obj.FileType.includes('image'))
                    if (images.length > 0) {
                    return `${this.$url}/downloadfile/${images[0].ID}`
                    }
                    else {
                    return ''
                    }
                }
                else {
                    return ''
                }
            }
        }
    }
</script>